import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

import { getGridItemWidth } from '@/utils/gridItemWidth';

const GRID_GAP = theme.spacing[3];

export const styles = StyleSheet.create((_, rt) => ({
  page: {
    flex: 1,
    gap: theme.spacing[4],
    maxWidth: rt.screen.width,
  },

  grid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: GRID_GAP,
    paddingTop: theme.spacing[3],
  },
  timeSlotSkeletonContainer: (numColumns: number) => ({
    width: getGridItemWidth({
      screenWidth: Math.min(theme.breakpoints.tablet, rt.screen.width),
      horizontalPadding: theme.spacing[5] * 2,
      gap: GRID_GAP,
      numColumns,
    }),
  }),
  timeSlotSkeleton: {
    borderRadius: theme.borderRadius.m,
  },
}));
